// extracted by mini-css-extract-plugin
export default {"container":"No-z","ratingLayout":"Oo-z","ratingLabel":"Po-z","nonInteractiveRatingLabel":"Qo-z"};